module.exports = __webpack_public_path__ + "img/dots.267b073e.svg";